/**
 * A plain primary-button click with no modifier keys. Modified clicks
 * (⌘/ctrl/alt/shift, non-left button) or an already-handled event should fall
 * through to the browser's native new-tab navigation rather than open the modal.
 */
export const isUnmodifiedPrimaryClick = (event) => event.button === 0 && !event.defaultPrevented && !event.metaKey && !event.altKey && !event.ctrlKey && !event.shiftKey;
/** View-only roles must not reach the document via ⌘/ctrl/middle-click on the classic href. */
export const shouldInterceptDocumentOpen = (event, interceptAllClicks) => interceptAllClicks || isUnmodifiedPrimaryClick(event);
